export default __webpack_public_path__ + "static/media/career-bg.5ab231c6.webp";